
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqDsqSS6tbulwJE1wxSxF5lt1HzBQL_hKXKpESfCHOsXIMeta } from "/codebuild/output/src4118409579/src/src/pages/faq.vue?macro=true";
import { default as menuJRq5UHaecLR6ttjcYhG_45AUKB4PJl4Y9wKLWXReUGPswMeta } from "/codebuild/output/src4118409579/src/src/pages/menu.vue?macro=true";
import { default as indexrlCB4110w5RspaHpPIQfwPqiVsHrqErtRj6KgJRwbNEMeta } from "/codebuild/output/src4118409579/src/src/pages/index.vue?macro=true";
import { default as contacteovXZ_455OB_45KGSpX_45yq_a2hd4ma_1CyM8VoMhE1wRZeoMeta } from "/codebuild/output/src4118409579/src/src/pages/contact.vue?macro=true";
import { default as tutorialJM1eJjfc9Z4L7QUpKp4bhisUIxoxFiiS5qmXGg5DoVkMeta } from "/codebuild/output/src4118409579/src/src/pages/tutorial.vue?macro=true";
import { default as agreement_45Xi275Bk4xICWYoyRJv_456B7dh4E9fzh9pwYx5pXcwhoMeta } from "/codebuild/output/src4118409579/src/src/pages/agreement.vue?macro=true";
import { default as about_45passh52aytQFbP2au7VPINTk4D9_458FOq0oX_DEy5hIg7fXsMeta } from "/codebuild/output/src4118409579/src/src/pages/about-pass.vue?macro=true";
import { default as indexhNtDQDHnQ8tWBk06T3G1dHG5SI8RNOYCaPUxEN8WFV0Meta } from "/codebuild/output/src4118409579/src/src/pages/card/index.vue?macro=true";
import { default as _91id_939c1lx4iyfWVsbM00mkSCi7xvX_45iOFdMLh7CoSn31JxoMeta } from "/codebuild/output/src4118409579/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceAA5bNoD6EtwmuU7IkHXx9WOdz7nzpStzBuQrH8BpPOYMeta } from "/codebuild/output/src4118409579/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_45HhmTAZqvcA3NXpyDLLNDFh4WATh_EJX4wwIxYOpkOYMeta } from "/codebuild/output/src4118409579/src/src/pages/notice/[id].vue?macro=true";
import { default as indexlkUF_45UslfmY5ylPE9FfGSMPGGiJQfFoo89wmnAi5jfIMeta } from "/codebuild/output/src4118409579/src/src/pages/coupon/index.vue?macro=true";
import { default as indexd_45UTYJOIdWDAsHm3Mx2L2aLGtQeZO4v_45QlLwcgdP4_45kMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/index.vue?macro=true";
import { default as index_ykif6UkoKSrcWPp5pBIXHiuJvBmZLY6axSDgPh8mOYMeta } from "/codebuild/output/src4118409579/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93AOe5kDSBs2y2DAsvO91igm8uh1j_9KkpAkaaUrspODkMeta } from "/codebuild/output/src4118409579/src/src/pages/parking/[id].vue?macro=true";
import { default as indexkQ8bLxulpLnqOBQc3PTq28OSRuDs88CdVH41RZCxIx8Meta } from "/codebuild/output/src4118409579/src/src/pages/history/index.vue?macro=true";
import { default as indexEQ7EhmU_45qK_45_W5u8bofAjz7OPf1Db51LlFW_yDgvWfEMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/index.vue?macro=true";
import { default as indexDApf689KU79K3INqW_pXGzYkTPKKQdrzaOQKU5omnEAMeta } from "/codebuild/output/src4118409579/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexU1Iav5SyZ1sbVSVukzcUl_KXOxI7kOCAY_16PZYUNZgMeta } from "/codebuild/output/src4118409579/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi42bPO5wIsXkp5cMEKMuKCQb0CmYu5QAA_4565ImHCf4i4Meta } from "/codebuild/output/src4118409579/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editPQEAfOjiKcOOKfwMPL4MwoOS3NCzbT9WOI_PxnWtj6oMeta } from "/codebuild/output/src4118409579/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementT3_45qirWIcqlGkyc15RCRvD68b_45GGVJQp93iQKwyhmcIMeta } from "/codebuild/output/src4118409579/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexJHr2JpPaypo6EBVfnFMTRnPA8XXisk7ipZfU_45nxY7S4Meta } from "/codebuild/output/src4118409579/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dyfdNkM36GPcBOMpqSSY1bVmZIzfG7Qr8iN_45ugiuR8HYMeta } from "/codebuild/output/src4118409579/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmM_45Fky3VFzpRos0fGgIxqkZt1f_glRU84O3Fl1XvcKPwMeta } from "/codebuild/output/src4118409579/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexeY7ccigaT2WXSwwpSUHmA3OZKhdYsfbZKOTO0Ttf5CEMeta } from "/codebuild/output/src4118409579/src/src/pages/card/create/index.vue?macro=true";
import { default as indexWVeW23Rp4EGOQUmYqeP3jagps_45bfOUke8SqvTiJXQ_UMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmmlb5wy2JWjuL9wRqO3dXrsg_nR8snaz65ub0fO0AUkQMeta } from "/codebuild/output/src4118409579/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmNj5j19ddpfuYBm44QUD0yudKfdE2JmJ7IoBg9e56KosMeta } from "/codebuild/output/src4118409579/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completetYoef8QiM_cP1bMv9_45V9C6a_ujFcJNmwS_45DhyO4iUl4Meta } from "/codebuild/output/src4118409579/src/src/pages/membership/complete.vue?macro=true";
import { default as registerJM2DUpzx2TSFaG62tyM6pZ0_45TikWuBn5j_Ro8EWCUPUMeta } from "/codebuild/output/src4118409579/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93GBw4nQ7A7t2YMpkrbGxY4oa6XgkXyQtPN24KJHVp12oMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm36apkr1WE6LFxmfqgK5ZYQ6mE1cHiWi2Mkkz6BrnvbgMeta } from "/codebuild/output/src4118409579/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93rihukagHcELUX2GAIk5kplrQuatgaC_45yyero8E_Q_CgMeta } from "/codebuild/output/src4118409579/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexXvd_45PqBbewTR7tB3lNEFDdTZFVjO0aaCvwA0WAsUXzAMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codei9_45e__majRHATD42Bk_45yFTwu3SVE0Yola4ePeP3ygxYMeta } from "/codebuild/output/src4118409579/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeLP81hrmLgUDrwtZucSzOMMFs_45I_45J5shLwhF49yxUmLkMeta } from "/codebuild/output/src4118409579/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete341rsVSyBin6N_JcinijEwV1XmREsvqfRGTOzPVP310Meta } from "/codebuild/output/src4118409579/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerIbNXBsPN_p1ozSg18cKSKERVDjyvUhNeaCpPDDnuTXEMeta } from "/codebuild/output/src4118409579/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeJlVk0qdVRy41VKrlzfsMIkKMOzhNYP9jgVLY5Uss6GwMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexKuNz89fXQbzPOkcsjfIWD5uA0dHp_45vGEnO5HVw2Zc8UMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmSs3ALCjw3BaRcoS_zkGGCe9ZNkNdu7Q5cnc3SOe2DkAMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete_h7GhF8X_buWPHaxeSWfq8OdJ0GVDUlNeQ5lEBefS9sMeta } from "/codebuild/output/src4118409579/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexVfikog5K6EVPhdhMhSukqDu9jDOr459W8dNQyb3_d8AMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93yMC8z7QDTGPeVlzGCf5Q_45g3w3OPH_45qpLcYBgv_RBnoEMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete7VQA7xlqCtGQ4v3keXH_9yJMvoqv_45Y_wCN6kCanzQDIMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasXcoSjogVWLZ_45820YEK4tX8Fp0rZG7_dw_45b98azBv4LIMeta } from "/codebuild/output/src4118409579/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample0d6Wa53I8Svg_45GaoFJ7h9ef9YrNNXeGP5Rjuw_GSIIcMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailZ7_BaM2vhpsJn4PdN8IWoW_45ZI6IEF6ycgkY6zyepV3gMeta } from "/codebuild/output/src4118409579/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmp3f0crMgpjw528R3iYMPSqghFyvxngPE3tsbxcNUta8Meta } from "/codebuild/output/src4118409579/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentsJX_Mc5TUZc_459zmu1ACW0_45IJ6nkF5LI68cKSJEniZdkMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm6DbuaOtu9x0BofuMKy60PhaZFw628V2a1TSBZwJvgd0Meta } from "/codebuild/output/src4118409579/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate6_ptxBhnIRPCkW2Hs8tYznKXi90J0gDAI4NGdBfDNr8Meta } from "/codebuild/output/src4118409579/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as complete4r1M_qZRkj7YxTtmLeJp4Co5cmEYddog0yK1Bu2VP68Meta } from "/codebuild/output/src4118409579/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeAkn0OLZIuoip57Mv_45qITVhbKA0BqDwRCsv2Nm7tXmh0Meta } from "/codebuild/output/src4118409579/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordEHWiFw2EQ3wQ4ue_MB3tAUtBttjOLiwUhSo_45ThzYTPoMeta } from "/codebuild/output/src4118409579/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasvYfyfk6cKgcOj_45V5oGzGpgcnTwCFbGNFHVEL2EQb2cIMeta } from "/codebuild/output/src4118409579/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register4PG3Yws6a9zhqaRsEtMoRHYrlM4gPvQ4FuiZ0PiHdg8Meta } from "/codebuild/output/src4118409579/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codez_45HW1jK_45gtR1IX2pBDpymM1RsjuZmEyGam_45UrFbmdBEMeta } from "/codebuild/output/src4118409579/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexDD4qD6kGmidDI37jGjEzYzh3aBzajMUYdxkxKO_45YZw0Meta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexzSX45qOTxamYocqRHkgVIy_r54enJO8lRcp1LlFwm7MMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexMJPWIXLehtlg1CQKY35IbS6ydwVffGLvjMUGDYbnM7QMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index4GZCeO11d_xkgycsqa9apobhOwygxwlDjENIGAyEhTEMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update5YhwbqnT6V5XxgJGajDeGgYXIfERu9aHvGm7us4J38oMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completesQI808sLnVauJWp3wnDjqMdkRffY5mc3QgqjsbDW2jYMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmsHBs2yO6WLTanMZ9E56QWs29qoKx0REtCLQSrWzO9bAMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexS5xXFYqSWhb1JNXObHsq3_45pp8_rNUCPJbR1LKeKmCSsMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeKxaKgi88CHml13bge2NyuuUHKrSTX8gO3KliTG_45IKcoMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateeFIqB9kWWragiBgiI1CopMhoSzfAeVF7ls0C6vcKRS8Meta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexqQSLOxKuHr722Epzf2mtS7nybh_45VvNxFv0EXGcQUL8wMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexJmrwag4dKBG3Nawp8dCF7H4_450boSAjMZ6UNqf5eQykoMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeC9mYviHm9CKCaDoGn3_7PAIfZZYkzoWmFq7dibtyCjMMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexgXlKcCt4UHOBQBsbfug8P5DuVoIC3Wgoj95C4q8YbakMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code_45iQAS8KwcMQr38ZHVM9I_45zuFDlJwbjGfajRoUGrMWsgMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexVenQcXuG5JVQRgachQEw3NGuXI_458YnDxgxeg9TV_45meUMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index54eNKgfj5yUDNLq1xlTPT_45L_45DQm3T6HTTJrKvCEgs0cMeta } from "/codebuild/output/src4118409579/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexJaFxoKdxV8ZzVHueSKG9wdivrEHtZE3NgAde2rkK3D0Meta } from "/codebuild/output/src4118409579/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateFz_z1693NPHO_50_45ZB9fMBplLqG3_n0HjdvLqQLwCsAMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmrqECVN_45JDyVozy9RR3RIYYt_1ecciBmunQYeVkkbXHMMeta } from "/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuJRq5UHaecLR6ttjcYhG_45AUKB4PJl4Y9wKLWXReUGPswMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexrlCB4110w5RspaHpPIQfwPqiVsHrqErtRj6KgJRwbNEMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexlkUF_45UslfmY5ylPE9FfGSMPGGiJQfFoo89wmnAi5jfIMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexkQ8bLxulpLnqOBQc3PTq28OSRuDs88CdVH41RZCxIx8Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexDApf689KU79K3INqW_pXGzYkTPKKQdrzaOQKU5omnEAMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexU1Iav5SyZ1sbVSVukzcUl_KXOxI7kOCAY_16PZYUNZgMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexeY7ccigaT2WXSwwpSUHmA3OZKhdYsfbZKOTO0Ttf5CEMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmmlb5wy2JWjuL9wRqO3dXrsg_nR8snaz65ub0fO0AUkQMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmNj5j19ddpfuYBm44QUD0yudKfdE2JmJ7IoBg9e56KosMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completetYoef8QiM_cP1bMv9_45V9C6a_ujFcJNmwS_45DhyO4iUl4Meta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerJM2DUpzx2TSFaG62tyM6pZ0_45TikWuBn5j_Ro8EWCUPUMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm36apkr1WE6LFxmfqgK5ZYQ6mE1cHiWi2Mkkz6BrnvbgMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codei9_45e__majRHATD42Bk_45yFTwu3SVE0Yola4ePeP3ygxYMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeLP81hrmLgUDrwtZucSzOMMFs_45I_45J5shLwhF49yxUmLkMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete341rsVSyBin6N_JcinijEwV1XmREsvqfRGTOzPVP310Meta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerIbNXBsPN_p1ozSg18cKSKERVDjyvUhNeaCpPDDnuTXEMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmSs3ALCjw3BaRcoS_zkGGCe9ZNkNdu7Q5cnc3SOe2DkAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete_h7GhF8X_buWPHaxeSWfq8OdJ0GVDUlNeQ5lEBefS9sMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexVfikog5K6EVPhdhMhSukqDu9jDOr459W8dNQyb3_d8AMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete7VQA7xlqCtGQ4v3keXH_9yJMvoqv_45Y_wCN6kCanzQDIMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample0d6Wa53I8Svg_45GaoFJ7h9ef9YrNNXeGP5Rjuw_GSIIcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailZ7_BaM2vhpsJn4PdN8IWoW_45ZI6IEF6ycgkY6zyepV3gMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmp3f0crMgpjw528R3iYMPSqghFyvxngPE3tsbxcNUta8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentsJX_Mc5TUZc_459zmu1ACW0_45IJ6nkF5LI68cKSJEniZdkMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm6DbuaOtu9x0BofuMKy60PhaZFw628V2a1TSBZwJvgd0Meta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(complete4r1M_qZRkj7YxTtmLeJp4Co5cmEYddog0yK1Bu2VP68Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeAkn0OLZIuoip57Mv_45qITVhbKA0BqDwRCsv2Nm7tXmh0Meta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordEHWiFw2EQ3wQ4ue_MB3tAUtBttjOLiwUhSo_45ThzYTPoMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register4PG3Yws6a9zhqaRsEtMoRHYrlM4gPvQ4FuiZ0PiHdg8Meta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codez_45HW1jK_45gtR1IX2pBDpymM1RsjuZmEyGam_45UrFbmdBEMeta || {},
    component: () => import("/codebuild/output/src4118409579/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src4118409579/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]